function displayTemperature(response) {
  let temperatureElement = document.querySelector("#current-temperature");
  let cityElement = document.querySelector("#current-city");
  let descriptionElement = document.querySelector("#current-description");
  let humidityElement = document.querySelector("#current-humidity");
  let windElement = document.querySelector("#current-wind");
  let iconElement = document.querySelector("#current-weather-icon");

  let currentWeather = response.data.daily[0]; // Use the first item in the daily array for current weather

  cityElement.innerHTML = response.data.city;
  temperatureElement.innerHTML = Math.round(currentWeather.temperature.day);
  descriptionElement.innerHTML = currentWeather.condition.description;
  humidityElement.innerHTML = `${currentWeather.temperature.humidity}%`;
  windElement.innerHTML = `${currentWeather.wind.speed} km/h`;

  iconElement.src = currentWeather.condition.icon_url;
  iconElement.alt = currentWeather.condition.description;

  // Display 5-day forecast
  displayForecast(response.data.daily);

  document.querySelector("#loading").style.display = "none";
}

function displayForecast(forecastData) {
  let forecastContainer = document.querySelector("#forecast");
  forecastContainer.innerHTML = ''; // Clear any existing forecast data

  // Loop through the next 5 days of forecast data
  forecastData.slice(1, 6).forEach((day) => {
    let dayElement = document.createElement('div');
    dayElement.classList.add('forecast-day');

    // Format day names (e.g., "Mon", "Tue")
    let date = new Date(day.time * 1000);
    let options = { weekday: 'short' };
    let dayName = date.toLocaleDateString('en-US', options);

    dayElement.innerHTML = `
      <h3 class="day">${dayName}</h3>
      <img src="${day.condition.icon_url}" alt="${day.condition.description}" />
      <div class="temperature">
        Max: <span>${Math.round(day.temperature.maximum)}°C</span> <br>
        Min: <span>${Math.round(day.temperature.minimum)}°C</span>
      </div>
    `;

    forecastContainer.appendChild(dayElement);
  });
}

function search(event) {
  event.preventDefault();
  let city = document.querySelector("#search-input").value;

  let apiKey = "56af82b04dfebb4da1e173d45bto3420"; 

  let apiUrl = `https://api.shecodes.io/weather/v1/forecast?query=${city}&key=${apiKey}&units=metric`;

  document.querySelector("#loading").style.display = "block";

  axios.get(apiUrl)
    .then(displayTemperature)
    .catch(error => {
      alert("City not found. Please try again.");
      document.querySelector("#loading").style.display = "none";
    });
}

function formatDate(date) {
  let minutes = date.getMinutes();
  let hours = date.getHours();
  let day = date.getDay();

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  if (hours < 10) {
    hours = `0${hours}`;
  }

  let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ];

  let formattedDay = days[day];
  return `${formattedDay} ${hours}:${minutes}`;
}

let searchForm = document.querySelector("#search-form");
searchForm.addEventListener("submit", search);

let currentDateElement = document.querySelector("#current-date");
let currentDate = new Date();

currentDateElement.innerHTML = formatDate(currentDate);
